import { render } from "./TryAgainBtn.vue?vue&type=template&id=b0107a3c&scoped=true&ts=true"
import script from "./TryAgainBtn.vue?vue&type=script&lang=ts"
export * from "./TryAgainBtn.vue?vue&type=script&lang=ts"

import "./TryAgainBtn.vue?vue&type=style&index=0&id=b0107a3c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0107a3c"]])

export default __exports__